import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin", { replace: true });
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        setUser(data);
        // Clean the hash and go to admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (_e) {
        navigate("/admin?auth_error=1", { replace: true });
      }
    };

    run();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="flex min-h-screen items-center justify-center bg-leaf-50"
    >
      <div className="flex flex-col items-center gap-3 text-leaf-800">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="font-display text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
